import { z } from "zod";
import { RoomStatus } from "../../../shared/types/rooms/RoomStatus";

const RoomSchema = z.object({
    id: z.string().uuid(),
    property_id: z.string().uuid(),
    room_type_id: z.string().uuid(),
    room_number: z.string(),
    sort_order: z.number().int().optional().default(0),
    status: z.enum(RoomStatus.map(s => s.value) as [string, ...string[]]),
    condition: z.enum(["clean", "dirty", "needs repair"]),
    created_at: z.string().datetime(),
    updated_at: z.string().datetime(),
});

const RoomTypeSchema = z.object({
    id: z.string().uuid(),
    property_id: z.string().uuid(),
    // Nullable: property deactivation nulls this server-side (DeactivatePropertyChannexJob).
    channex_id: z.string().uuid().nullable(),
    name: z.string(),
    description: z.nullable(z.string()).optional(),
    no_of_beds: z.number(),
    cut_of_days: z.number(),
    is_free_allotment: z.boolean(),
    is_auto_assign: z.boolean(),
    is_dynamic_pricing: z.boolean(),
    total_rooms: z.number(),
    created_at: z.string().datetime(),
    updated_at: z.string().datetime(),
    occ_adults: z.number(),
    occ_children: z.number(),
    occ_infants: z.number(),
    default_occupancy: z.number(),
    room_kind: z.string(),
    capacity: z.number(),
    rooms: z.array(RoomSchema),
});

const PaginationSchema = z.object({
    current_page: z.number(),
    from: z.number(),
    to: z.number(),
    total: z.number(),
    per_page: z.number(),
    last_page: z.number(),
    next_page: z.number(),
    prev_page: z.number(),
    path: z.string().url(),
    next_page_url: z.nullable(z.string().url()),
    prev_page_url: z.nullable(z.string().url()),
    first_page_url: z.string().url(),
    last_page_url: z.string().url(),
});

const GetAllRoomTypeResponseSchema = z.object({
    success: z.boolean(),
    message: z.string(),
    code: z.number(),
    data: z.array(RoomTypeSchema),
    pagination: PaginationSchema.optional(),
});

export { RoomSchema, RoomTypeSchema, GetAllRoomTypeResponseSchema };
export type RoomType = z.infer<typeof RoomTypeSchema>;
export type Room = z.infer<typeof RoomSchema>;
export type GetAllRoomTypeResponse = z.infer<typeof GetAllRoomTypeResponseSchema>;
